import { ArrowUpRight, ExternalLink, Lock, X } from "lucide-react";
import { useEffect } from "react";

const KIWIFY_CHECKOUT_URL = "https://pay.kiwify.com.br/m7pNHl2";

export default function CheckoutModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className="checkout-modal" role="dialog" aria-modal="true" aria-labelledby="checkout-title" data-testid="checkout-modal-container">
        <button className="modal-close" type="button" onClick={onClose} aria-label="Fechar pagamento" data-testid="checkout-modal-close"><X size={19} /></button>
        <div className="modal-kicker"><Lock size={14} /> PAGAMENTO ÚNICO · R$ 29,99</div>
        <h2 id="checkout-title">Um passo de cada vez.</h2>
        <p className="modal-lead">Você será levado ao checkout seguro da Kiwify. O acesso ao livro será liberado automaticamente depois que o webhook confirmar `compra_aprovada`.</p>
        <div className="checkout-steps"><span><b>01</b> checkout Kiwify</span><span><b>02</b> aprovação automática</span><span><b>03</b> leitura protegida</span></div>
        <a className="button button-primary button-wide" href={KIWIFY_CHECKOUT_URL} data-testid="checkout-kiwify-button">Pagar com Kiwify <ArrowUpRight size={17} /></a>
        <small className="modal-footnote"><ExternalLink size={12} /> Nenhum dado de cartão é armazenado neste site.</small>
      </div>
    </div>
  );
}
